// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".warning-text[data-v-0e872dfc]{color:#f20000;font-size:16px}", "",{"version":3,"sources":["webpack://./resources/assets/js/views/portfolios/building/Information.vue"],"names":[],"mappings":"AACA,+BAEE,aAAA,CADA,cACF","sourcesContent":["\n.warning-text {\n  font-size: 16px;\n  color: #f20000;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
